<template>
  <div class="container">
    <img src="static/img/clockbg.png" alt="">
    <img src="static/img/clock.png" class="part" style="width:20vw;top:10vw;left:10vw;" alt="">
    <div class="part" style="left:32vw;top:13vw;color:white;">
      <p>当前志愿者服务时长</p>
      <h3>{{hour}}小时</h3>
    </div>
    <van-list
      v-model="listloading"
      :immediate-check="false"
      :finished="listfinished"
      finished-text="没有更多啦"
      @load="listload_more()"
    >
      <div class="flex" v-for="(item,index) in list" :key="index">
        <div>
          <p class="title">{{item.task_title}}</p>
          <p class="date">{{item.time}}</p>
        </div>
        <p class="time">+{{item.hour_fmt}}</p>
      </div>
    </van-list>
  </div>
</template>
<script>
export default {
  name:'hourslog',
  data() {
    return{
      list:[],
      listloading:false,
      listfinished:false,
      listpage:1,
      hour:'',
    }
  },
  created(){
    this.$axios({
      method:'post',
      url:'/api/home/hour_log',
    }).then(res => {
      console.log(res.data);
      this.list = res.data.data.list;
      this.hour = res.data.data.member.hours;
    })
  },
  methods:{
    listload_more(){
      this.listpage += 1;
      var that = this;
      setTimeout(function(){
        that.$axios({
          method:'post',
          url:'/api/home/hour_log',
          data:that.qs.stringify({
            page:that.listpage
          })
        }).then(res => {
          console.log(res.data);
          that.list = that.list.concat(res.data.data.list);
          that.listloading = false;
          if (res.data.data.list.length == 0) {  //数据全部加载完成
            that.listfinished = true;
          }else{
            that.listfinished = false;
          }
        })
      },500)
    }
  }
}
</script>
<style scoped>
img{
  width: 100%;
  display: block;
}
.flex{
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #f2f2f2;
}
.time{
  white-space: nowrap;
  margin-left: 5px;
  color: orange;
  font-weight: bold;
}
.title{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.date{
  font-size: 12px;
  color: grey;
}
.part{
  position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/components/hourslog.vue